import React from 'react';
import PropTypes from 'prop-types';

import SplitText from '../SplitText';

const File = ({ content }) => {
  return <SplitText>{content.text}</SplitText>;
};

File.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string.isRequired
  }).isRequired
};

export default File;
